$(document).ready(function() {
	$('.js-newsletter-signup-form').each(function() {
		let nyhetsbrev_selected = localize_profile.selected;
		var $form = $(this);
		var $email = $form.find('input[name="email"]');
		var $consentCheck = $form.find('input[name="consentTermsRevision"]');
		var $interests = $form.find('.js-interests-select');
		var $hdnTitle = $form.find('input[name="title"]');
		var $hdnInterests = $form.find('input[name="interests"]');
		var $titleMain = $form.find('.js-title-main');
		var $titleAnnan = $form.find('.js-title-annan');
		var $titleSpecialitet = $form.find('.js-title-specialitet');
		var $titleUnderlakare = $form.find('.js-title-underlakare');
		var $titleSjukskoterska = $form.find('.js-title-sjukskoterska');
		var subSelects = $titleAnnan.add($titleSpecialitet).add($titleUnderlakare).add($titleSjukskoterska);
		subSelects.find('select').select2({
			closeOnSelect: false,
			placeholder: localize_profile.placeholder,
			allowClear: true,
			tags: false
		}).on('select2:open select2:close select2:select select2:unselect', function (e) {
			$(e.target).siblings('.select2').find('.select2-search__field').attr('placeholder', e.target.selectedOptions.length + ' ' + nyhetsbrev_selected).css('width', '100%');
		}).trigger('select2:close').on('select2:open select2:close', function(e) {
			serializeTitles(e); //validateMembershipForm();
		});

		//for certain title values, show subtitle choices
		$titleMain.on('change', (e) => {
			switch(e.target.value) {
				case localize_profile.titleOtherDoc:
					subSelects.removeClass('active');
					$titleAnnan.addClass('active');
					break;
				case localize_profile.titleSTDoc:
					subSelects.removeClass('active');
					$titleSpecialitet.addClass('active');
					break;
				case localize_profile.titleAssistDoc:
					subSelects.removeClass('active');
					$titleUnderlakare.addClass('active');
					break;
				case localize_profile.titleNurse:
					subSelects.removeClass('active');
					$titleSjukskoterska.addClass('active');
					break;
				default:
					subSelects.removeClass('active');
			}
			serializeTitles();
			$form.find('.validate-error').remove();
			$form.find('.outline-red').removeClass('outline-red');
		});

		//makes yet another custom dropdown instead of a regular <select> because apparently just using free stuff from the browser is no fun or whatever and the custom dropdown library we're already using isn't good enough or something?
		///Who doesn't want to spend time re-inventing the wheel, right?
		function stylishDropdown($select, fnShouldHaveArrow) {
			var $body = $(document);
			var $wrap = $(document.createElement('div')).addClass('custom-select active');
			var $itemsWrapper = $(document.createElement('div')).addClass('select-items hidden');
			$select.children('option').each(function(i, opt) {
				var divOpt = $(document.createElement('div')).html(opt.innerText);
				$itemsWrapper.append(divOpt);
				divOpt.data('value', opt.value); //keep on passing the fucking value, re-inventing the wheel
				if(fnShouldHaveArrow(opt.value)) {
					divOpt.addClass('with-arrow');
				}
			});
			$wrap.append($itemsWrapper);
			//$shown is the control that shows whatever the user has selected
			var $shown = $(document.createElement('div')).addClass('select-selected').text($select.val());
			$itemsWrapper.on('click', 'div', function(e) {
				var val = $(this).text();
				$shown.text(val);
				$select.val($(this).data('value')).trigger('change');
			});
			$wrap.append($shown);
			$shown.on('click', function(e) {
				$itemsWrapper.removeClass('hidden');
				$body.on('click', closeDropdown);
				return false;
			});
			function closeDropdown() {
				$itemsWrapper.addClass('hidden');
				$body.off('click', closeDropdown);
			}
			$select.after($wrap);
			$select.hide();
		}
		stylishDropdown($titleMain, function(val) {return (val === localize_profile.titleOtherDoc || val === localize_profile.titleSTDoc || val === localize_profile.titleAssistDoc || val === localize_profile.titleNurse)});
		//$titleMain.trigger('change').on('change', validateMembershipForm);

		//since we "can't" use built in browser controls for some fucking reason, serialize all the different choices in dropdowns to hidden input forms that we then POST to the server
		function serializeTitles() {
			let strVal = $titleMain.val();
			var subtitles = subSelects.filter('.active').find('select');
			if(subtitles.length > 0) {
				for(var i = 0; i < subtitles.length; i++) {
					for(var j = 0; j < subtitles[i].selectedOptions.length; j++) {
						strVal += ',' + subtitles[i].selectedOptions[j].value;
					}
				}
			}
			$hdnTitle.val(strVal);
		}

		$interests.select2({
			closeOnSelect: false,
			allowClear: true,
			tags: false,
			placeholder: localize_profile.interest_placeholder,
		}).on('select2:open select2:close select2:select select2:unselect', function (e) {
			$(e.target).siblings('.select2').find('.select2-search__field').attr('placeholder', e.target.selectedOptions.length + ' ' + nyhetsbrev_selected).css('width', '100%');
		}).on('select2:open select2:close', function(e) {
			let strVal = '';
			for(var i = 0; i < e.target.selectedOptions.length; i++) {
				strVal += ',' + e.target.selectedOptions[i].value;
			}
			$hdnInterests.val(strVal.substring(1));
		});
		//$interests.trigger('select2:close').on('select2:open select2:close', validateMembershipForm); //trigger correct placeholder
		//$consentCheck.add($email).on('change', validateMembershipForm);

		//validates the form, and displays possible error messages in the right place. Returns a bool indicating if the form is currently valid or not
		function validateMembershipForm() {
			serializeTitles(); //make sure these are written before validation
			var isValid = true;
			//reset
			$form.find('.outline-red').removeClass('outline-red');
			$form.find('.validate-error').remove();
			//check if the email is valid (relies on built-in browser validation of input[type=email])
			if(!$email[0].validity.valid) {
				$email.addClass('outline-red');
				$email.before($(document.createElement('p')).addClass('validate-error no-mb').text(localize_profile.invalid_email));
				isValid = false;
			}
			//check if at least one interest have been chosen
			/*if(!$hdnInterests.val()) {
				$interests.addClass('outline-red');
				$interests.after($(document.createElement('p')).addClass('validate-error').text(localize_profile.invalid_interests));
				isValid = false;
			}*/
			//check if the title, and possible subtitle, has been set
			if(!$hdnTitle.val()) {
				$titleMain.next().find('.select-selected').addClass('outline-red');
				$titleMain.after($(document.createElement('p')).addClass('validate-error mb-05').text(localize_profile.invalid_title));
				isValid = false;
			} else {
				//if any of these titles have been chosen, make sure they've also filled in the subtitle
				var chosenTitle = $hdnTitle.val();
				if(chosenTitle.startsWith(localize_profile.titleOtherDoc) && chosenTitle.length === localize_profile.titleOtherDoc.length) {
					$titleAnnan.find('.select2-container--default').addClass('outline-red');
					$titleAnnan.find('.select2-container--default').after($(document.createElement('p')).addClass('validate-error').text(localize_profile.invalid_title));
					isValid = false;
				}
				if(chosenTitle.startsWith(localize_profile.titleSTDoc) && chosenTitle.length === localize_profile.titleSTDoc.length) {
					$titleSpecialitet.find('.select2-container--default').addClass('outline-red');
					$titleSpecialitet.find('.select2-container--default').after($(document.createElement('p')).addClass('validate-error').text(localize_profile.invalid_title));
					isValid = false;
				}
				if(chosenTitle.startsWith(localize_profile.titleAssistDoc) && chosenTitle.length === localize_profile.titleAssistDoc.length) {
					$titleUnderlakare.find('.select2-container--default').addClass('outline-red');
					$titleUnderlakare.find('.select2-container--default').after($(document.createElement('p')).addClass('validate-error').text(localize_profile.invalid_title));
					isValid = false;
				}
				if(chosenTitle.startsWith(localize_profile.titleNurse) && chosenTitle.length === localize_profile.titleNurse.length) {
					$titleSjukskoterska.find('.select2-container--default').addClass('outline-red');
					$titleSjukskoterska.find('.select2-container--default').after($(document.createElement('p')).addClass('validate-error').text(localize_profile.invalid_title));
					isValid = false;
				}
			}
			//user has to consent
			/*if(!$consentCheck.is(':checked')) {
				$consentCheck.closest('label').addClass('outline-red').after($(document.createElement('p')).addClass('validate-error').text(localize_profile.invalid_consent));
				isValid = false;
			}*/
			return isValid;
		}

		let currentlyPosting = false;
		$form.on('click', '.js-save-profile', function(e) {
			e.preventDefault();
			$form.find('.validate-success').remove();
			if(currentlyPosting) {return;} //prevent double-submits

			var $button = $(this);

			if(validateMembershipForm()) {
				$.ajax({
					dataType: "json",
					type: "POST",
					data: $form.serialize(),
					url: $form.attr('action'),
					beforeSend: function() {
						currentlyPosting = true;
					},
					success: function(data) {
						currentlyPosting = false;
						if(data['statusHintCode'] === 'created' && window.gtag) {
							gtag('event', 'sign_up');
						}
						if(data['redirectUrl']) {
							window.location = data['redirectUrl'];
						} else {
							if(data['error']) {
								$form.append($('<p class="validate-error">'+data['error']+'</p>'));
								//$('<p class="validate-error">'+data['error']+'</p>').insertAfter($button);
							} else {
								$form.append($('<p class="validate-success">'+localize_profile.member_save+'</p>'));
								//$button.val(localize_profile.member_save);
								//$button.html(localize_profile.member_save);
								if(localize_profile.logged_in && !localize_profile.fully_logged_in) {
									$('.responsive-tabs a').each(function(i,el){
										if($(el).hasClass('disabled')) {
											$(el).removeClass('disabled');
											$(el).attr('href',$(el).data('link'));
										}
									});
									$('.member-name').html(data['name']);
									$('.member-title').html(data['title']);
									$('.primary-menu .menu-link').addClass('hidden');
									$('.primary-menu .member-link').removeClass('hidden');
									$('.primary-menu .member-sublinklink').removeClass('hidden');
									$('.primary-menu .member-link a img').before(data['initials']);
								}
							}
						}
					},
					error: function(xhr, status, error) {
						currentlyPosting = false;
						$form.append($('<p class="validate-error">'+xhr.responseText+'</p>'));
						//$('<p class="validate-error">'+xhr.responseText+'</p>').insertAfter($button);
					}
				});
			}
		});
	});

	/* members page navigation, toggle hash active and icons active */
	$(document).on('click', '.page-template-page-profile .responsive-tabs a', function (e) {
		let $this = $(this);
		if(!$this.hasClass('log-out')) {
			e.preventDefault();
			if($this.hasClass('disabled')) {
				e.stopPropagation();
			} else {
				toggleMemberSubpage($this);
				location.hash = $this.attr('href');
			}
		}
	});
	function toggleMemberSubpage(link) {
		$('.responsive-tabs li').each(function (i, el) {
			$(el).removeClass('active');
			let image = $(el).find('a img');
			if ($(image).length > 0) {
				let default_image = $(image).attr('src').split('-active.svg');
				if (default_image.length > 1)
					$(image).attr('src', default_image[0] + '.svg');
			}
		});
		$('.member-tab-content').each(function (i, el) {
			$(el).removeClass('active');
		});
		let image = $(link).find('img');
		if ($(image).length > 0) {
			let default_image = $(image).attr('src').split('.svg');
			if (default_image.length > 1)
				$(image).attr('src', default_image[0] + '-active.svg');
		}
		$(link).parent().addClass('active');
		$('#' + $(link).attr('href').slice(1)).addClass('active');
	}
	if($('body').hasClass('page-template-page-profile') && location.hash) {
		$('.responsive-tabs a[href="'+location.hash+'"]').trigger('click');
	}

});
